<template>
  <div>
    <div class=" mainLoader" v-if="loading"></div>
    <div class="realbody">
      <div class="container" style="margin-top: 100px;">
        <div class="row">
          <div class="col-md-12 mainbody text-center">
            <h6 class="gray cocogothic spacing3-2 mgtop10">{{$t('r_title')}}</h6>
            <p class="r_panel_title mplus2p-r spacing4 black" style="margin-top: 30px;">{{$t('r_basic_info')}}</p>
            <p class="mplus2p-r spacing1-2 black" style="font-size: 0.75rem;">{{$t('r_sub_basic_info')}}</p>
            <p class="mplus2p-r spacing1-2 black" style="color:red;font-size: 0.75rem;">{{$t('r_recommended_browser')}}</p>
            <form style="margin-top: 30px;" @submit.self.prevent="doRegisterFirst" name="form">


              <div class="row input text-left" :class="{ invalid: $v.lastname.$error }">
                <div class="col-md-2"></div>
                <div class="col-md-2">
                  <label class="mplus2p-m spacing1-2 black peditlabel">{{$t('r_lastname')}} <span
                    style="color: red;">*</span></label>
                </div>
                <div class="col-md-6">
                  <div class="regselectboxs  form-group" style="min-width: 415px;">
                    <input style="min-height:50px" :placeholder="$t('unify_test')"
                           type="text"
                           autofocus
                           name="lastname"
                           id="lastname"
                           class="form-control login_widget"
                           @keydown.enter.prevent
                           v-model="$v.lastname.$model"/>
                    <div class="help-block" v-if="!$v.lastname.req && lastNameFocus">{{$t('required_filed')}}</div>
                  </div>
                </div>
              </div>

              <div class="row input text-left" :class="{ invalid: $v.firstname.$error}">
                <div class="col-md-2"></div>
                <div class="col-md-2">
                  <label class="mplus2p-m spacing1-2 black peditlabel">{{$t('r_firstname')}} <span style="color: red;">*</span></label>
                </div>
                <div class="col-md-6">
                  <div class="regselectboxs  form-group" style=" min-width: 415px;">
                    <input style="min-height:50px" :placeholder="$t('unify_test')"
                           type="text"
                           autofocus
                           name="firstname"
                           class="form-control login_widget"
                           @keydown.enter.prevent
                           v-model="$v.firstname.$model" />
                    <div class="help-block" v-if="!$v.firstname.req && firstNameFocus">
                      {{$t('required_filed')}}
                    </div>
                  </div>
                </div>
              </div>

              <div class="row input text-left" :class="{ invalid: $v.lastNamePhonetic.$error }">
                <div class="col-md-2"></div>
                <div class="col-md-2">
                  <label class="mplus2p-m spacing1-2 black peditlabel">{{$t('r_lastname_phonetic')}} <span
                    style="color: red;">*</span></label>
                </div>
                <div class="col-md-6">
                  <div class="regselectboxs  form-group" style="min-width: 415px;">
                    <input style="min-height:50px" :placeholder="$t('unify_test')"
                           type="text"
                           autofocus
                           name="lastNamePhonetic"
                           id="lastNamePhonetic"
                           class="form-control login_widget"
                           @keydown.enter.prevent
                           v-model="$v.lastNamePhonetic.$model"/>
                    <div class="help-block" v-if="!$v.lastNamePhonetic.req && lastNamePhonetic">{{$t('required_filed')}}</div>
                  </div>
                </div>
              </div>

              <div class="row input text-left" :class="{ invalid: $v.firstNamePhonetic.$error}">
                <div class="col-md-2"></div>
                <div class="col-md-2">
                  <label class="mplus2p-m spacing1-2 black peditlabel">{{$t('r_firstname_phonetic')}} <span style="color: red;">*</span></label>
                </div>
                <div class="col-md-6">
                  <div class="regselectboxs  form-group" style=" min-width: 415px;">
                    <input style="min-height:50px" :placeholder="$t('unify_test')"
                           type="text"
                           autofocus
                           name="firstNamePhonetic"
                           class="form-control login_widget"
                           @keydown.enter.prevent
                           v-model="$v.firstNamePhonetic.$model" />
                    <div class="help-block" v-if="!$v.firstNamePhonetic.req && firstNamePhoneticFocus">
                      {{$t('required_filed')}}
                    </div>
                  </div>
                </div>
              </div>

              <div class="row input text-left" :class="{ invalid: $v.initials.$error }">
                <div class="col-md-2"></div>
                <div class="col-md-2">
                  <label class="mplus2p-m spacing1-2 black peditlabel">{{$t('r_initials')}} <span style="color: red;">*</span></label>
                </div>
                <div class="col-md-6">
                  <div class="regselectboxs  form-group" style="min-width: 415px;">
                    <input style="min-height:50px" :placeholder="$t('unify_test')"
                           type="text"
                           class="form-control"
                           name="initials"
                           @keydown.enter.prevent
                           autofocus
                           v-model="$v.initials.$model"/>
                    <div class="help-block" v-if="!$v.initials.customValidation && initialsAlphaValidationFocus">{{$t('ep_initials_custom_validation')}}</div>
                    <div class="help-block" v-if="!$v.initials.req && initialsFocus">{{$t('required_filed')}}</div>
                  </div>
                </div>
              </div>
              <div class="row input text-left" :class="{ invalid: $v.email.$error }">
                <div class="col-md-2"></div>
                <div class="col-md-2">
                  <label class="mplus2p-m spacing1-2 black peditlabel">{{$t('r_email')}} <span style="color: red;">*</span> </label>
                </div>
                <div class="col-md-6">
                  <div class=" regselectboxs  form-group" style="min-width: 415px;">
                    <input style="min-height:50px" placeholder="yourname@example.com"
                           type="email"
                           class="form-control login_widget"
                           name="email"
                           :disabled="emailDisabled"
                           autofocus
                           v-model="$v.email.$model"  />
                    <div class="help-block" v-if="!$v.email.email">{{$t('r_c_email_validation')}}</div>
                    <div class="help-block" v-if="!$v.email.req && emailFocus">{{$t('required_filed')}}</div>
                  </div>
                </div>
              </div>
              <div class="row input text-left" :class="{ invalid: $v.password.$error }">
                <div class="col-md-2"></div>
                <div class="col-md-2">
                  <label class="mplus2p-m spacing1-2 black peditlabel">{{$t('r_password')}} <span style="color: red;">*</span>
                  </label>
                </div>
                <div class="col-md-6">
                  <div class="regselectboxs  form-group" style="min-width: 415px;">
                    <input style="min-height:50px" :placeholder="$t('passwordPlaceholder')"
                           type="password" class="form-control login_widget"
                           name="password"
                           autofocus
                           v-model="$v.password.$model"/>
                    <div class="help-block" v-if="!$v.password.minLength">{{$t('r_input_password_validation')}}</div>
                    <div class="help-block" v-if="!$v.password.req && passwordFocus">{{$t('required_filed')}}</div>
                  </div>
                </div>
              </div>
              <div class="row input text-left" :class="{ invalid: $v.cPassword.$error }">
                <div class="col-md-2"></div>
                <div class="col-md-2">
                  <label class="mplus2p-m spacing1-2 black peditlabel">{{$t('r_c_password')}} <span style="color: red;">*</span>
                  </label>
                </div>

                <div class="col-md-6">
                  <div class="regselectboxs form-group" style="min-width: 415px;">
                    <input style="min-height:50px" :placeholder="$t('passwordPlaceholder')"
                           type="password"
                           class="form-control login_widget"
                           name="cpassword"
                           autofocus
                           v-model="$v.cPassword.$model"/>
                    <div class="help-block" v-if="!$v.cPassword.sameAsPassword">{{$t('r_c_input_password_validation')}}</div>
                    <div class="help-block" v-if="!$v.cPassword.req && cPasswordFocus">{{$t('required_filed')}}</div>
                  </div>
                </div>
              </div>

              <div class="row   text-left" >
                <div class="col-md-2"></div>
                <div class="col-md-2 input" :class="{ invalid: (yearFocus && year == '') || (monthFocus && month == '') || (dayFocus && day == '') }">
                  <label class="mplus2p-m spacing1-2 black peditlabel">{{$t('r_dob')}}&nbsp;<span class="red">*</span></label>
                </div>
                <div class="col-md-6">
                  <div class="selectdiv input  regselectboxs  form-group" :class="{ invalid: yearFocus && year == ''}" style="min-width: 128px;">
                    <select class="form-control  "
                            name="year"
                            v-model="year"
                            autofocus>
                      <option class="mplus2p-r black" style="font-size: 0.875rem;"  value=""> {{$t('r_dob_year')}}
                      </option>
                      <option v-for="(i,index) of years" :key="index" class="mplus2p-r black" style="font-size: 0.875rem;" :value="i">{{i}}
                      </option>
                    </select>
                    <div v-if="(yearFocus && year == '') || (dayFocus && day == '') || (monthFocus && month == '')" class="help-block">{{$t('required_filed')}}</div>
                  </div>
                  <div class="selectdiv regselectboxs input form-group" :class="{ invalid: monthFocus && month == '' }" style="min-width: 128px;">
                    <select class="form-control"
                              name="month"
                              v-model="month"
                              autofocus>
                      <option class="mplus2p-r black" style="font-size: 0.875rem;" value=""> {{$t('r_dob_month')}}
                      </option>
                      <option v-for="(i,index) in months" :key='index' class=" black" style="font-size: 0.875rem;" :value="i">{{i}}</option>
                    </select>
                  </div>
                  <div class="selectdiv regselectboxs input form-group" :class="{ invalid: dayFocus && day == '' }" style="min-width: 128px;">
                    <select class="form-control" name="day"
                              v-model="day"
                              autofocus>
                      <option class="mplus2p-r black" style="font-size: 0.875rem;" value=""> {{$t('r_dob_day')}}
                      </option>

                      <option v-for="(i,index) in days" :key="index" class="mplus2p-r black" style="font-size: 0.875rem;" :value="i">{{i}}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-2"></div>
              </div>

              <div class="row input text-left" :class="{ invalid: jobSeekingFocus && jobSeeking.id == '' }">
                <div class="col-md-2"></div>
                <div class="col-md-2">
                  <label class="mplus2p-m spacing1-2 black peditlabel">{{$t('ep_job_seeking')}}&nbsp;<span class="red">*</span></label>
                </div>
                <div class="col-md-6">
                  <div class="selectdiv regselectboxs form-group" style="min-width: 415px;">
                    <select class="form-control" name="location"
                            v-model="jobSeeking.id"
                            autofocus>
                      <option v-if="jobSeeking.id == ''" class="mplus2p-r black" style="font-size: 0.875rem;" value="">{{$t('r_select')}}</option>
                      <option v-for="(i,index) of jobSeekings" :key="index" class="mplus2p-r black" style="font-size: 0.875rem;"
                              :value="i.id">{{lan == 'en' ? i.en_situation : i.jp_situation}}
                      </option>
                    </select>
                     <div v-if="jobSeekingFocus && jobSeeking.id == ''" class="help-block">{{$t('required_filed')}}</div>
                  </div>
                </div>
                <div class="col-md-2"></div>
              </div>

              <div class="row input text-left" :class="{ invalid: expertisFocus && expertise.id == '' }">
                <div class="col-md-2"></div>
                <div class="col-md-2">
                  <label class="mplus2p-m spacing1-2 black peditlabel">{{$t('expertise')}}&nbsp;<span class="red">*</span></label>
                </div>
                <div class="col-md-6">
                  <div class="selectdiv regselectboxs form-group" style="min-width: 415px;">
                    <select class="form-control" name="location"
                            v-model="expertise.id"
                            autofocus>
                      <option v-if="expertise.id == ''" class="mplus2p-r black" style="font-size: 0.875rem;" value="">{{$t('r_select')}}</option>
                      <option v-for="(i,index) of expertises" :key="index" class="mplus2p-r black" style="font-size: 0.875rem;"
                              :value="i.id">{{lan == 'en' ? i.en_expertise : i.jp_expertise}}
                      </option>
                    </select>
                     <div v-if="expertisFocus && expertise.id == ''" class="help-block">{{$t('required_filed')}}</div>
                  </div>
                </div>
                <div class="col-md-2"></div>
              </div>

              <div class="row text-left">
                <div class="col-md-2"></div>
                <div class="col-md-2">
                  <label class="mplus2p-m spacing1-2 black peditlabel">{{$t('ep_basic_info')}}</label>
                </div>

                <div class="col-md-6">
                  <div class="  form-group" style="min-width: 415px;">
                    <ul class="list-unstyled mt-3 peselectboxs  custom-wrapper" id="rtop-block">
                      <textarea rows="7" class="peditboxes pedittextarea form-control" name="profile_summary" v-model="desc" autofocus :placeholder="$t('unify_test')">
                      </textarea>
                    </ul>
                  </div>
                </div>
                <div class="col-md-2"></div>
              </div>

              <div class="row text-left" >
                <div class="col-md-2"></div>
                <div class="col-md-2">
                  <label class="mplus2p-m spacing1-2 black peditlabel">{{$t('r_gender')}}</label>
                </div>
                <div class="col-md-6">
                  <div class="regradioboxs manradio" style="min-width: 128px;" @click="clickedSex(1)">
                    <span class="mplus2p-r peradiotxt">{{$t('ep_male')}}</span>
                  </div>
                  <div class="regradioboxs womenradio" style="min-width: 128px;" @click="clickedSex(2)">
                    <span class="mplus2p-r peradiotxt">{{$t('ep_female')}}</span>
                  </div>
                  <div class="regradioboxs otherradio" style="min-width: 128px;" @click="clickedSex(3)">
                    <span class="mplus2p-r peradiotxt">{{$t('other')}}</span>
                  </div>
                </div>
                <div class="col-md-2"></div>
              </div>

              <div class="row text-left mt-4">
                <div class="col-md-2"></div>
                <div class="col-md-2">
                  <label class="mplus2p-m spacing1-2 black peditlabel">{{$t('r_location')}}</label>
                </div>
                <div class="col-md-6">
                  <div class="selectdiv regselectboxs form-group" style="min-width: 415px;">
                    <select class="form-control" name="location" v-model="location.id" autofocus>
                      <option v-if="location.id == ''" class="mplus2p-r black" selected style="font-size: 0.875rem;" value="">{{$t('r_select')}}</option>
                      <option v-for="(i,index) of locations" :key="index" class="mplus2p-r black" style="font-size: 0.875rem;" :value="i.id">
                        {{lan == 'en' ? i.en_location : i.jp_location}}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-2"></div>
              </div>

              <div class="row text-left mt-4">
                <div class="col-md-2"></div>
                <div class="col-md-2">
                  <label class="mplus2p-m spacing1-2 black peditlabel">{{$t('ep_national')}}</label>
                </div>
                <div class="col-md-6">
                  <div class="selectdiv regselectboxs form-group" style="min-width: 415px;">
                    <select class="form-control" name="location" v-model="sel_national.id" autofocus>
                      <option v-if="sel_national.id == ''" class="mplus2p-r black"  style="font-size: 0.875rem;" value="">{{$t('r_select')}}</option>
                      <option v-for="(i,index) of nationals" :key="index" class="mplus2p-r black" style="font-size: 0.875rem;" :value="i.id">
                        {{lan == 'en' ? i.en_national : i.jp_national}}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-2"></div>
              </div>

              <div class="row text-left">
                <div class="col-md-2"></div>
                <div class="col-md-2">
                  <label class="mplus2p-m spacing1-2 black peditlabel">{{$t('ep_languages')}}</label>
                </div>
                <div class="col-md-6">
                  <div class="  form-group" style="min-width: 415px;">
                    <ul class="list-unstyled mt-3 peselectboxs form-control custom-wrapper" id="lang-block">
                      <li v-for="(lang,index) of languages" :key="index">
                        <label :for="'lang'+lang.id" class="custom-control material-checkbox">
                          <input type="checkbox" class="material-control-input" v-model="check_language[index]"
                                 :id="'lang'+lang.id" :value="lang.id">
                          <span class="material-control-indicator"></span>
                          <span class="material-control-description">{{lan == 'en'?lang.en_language:lang.jp_language}}</span>
                        </label>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="col-md-2"></div>
              </div>
              <div class="row text-left">
                <div class="col-md-2"></div>
                <div class="col-md-2 input" :class="{ invalid: $v.requiredposition.$error}">
                  <label class="mplus2p-m spacing1-2 black peditlabel">{{$t('ep_required_position')}} <span style="color: red;">*</span></label>
                </div>
                <div class="col-md-6 errorClass" :class="{ invalid: $v.requiredposition.$error}">
                  <div class="row peselectboxs2">
                    <div class="col-md12">
                      <div class="form-group" style="min-width: 415px;">
                        <ul class="list-unstyled mt-3 peselectboxs form-control listError custom-wrapper" id="rtop-block">
                          <li v-for="(rtop,index) of requiredpositions" :key="index">
                            <label :for="'rtop'+rtop.id" class="custom-control material-checkbox">
                              <input type="checkbox" class="material-control-input"  @change="errorRequiredPosition()" v-model="check_require_position[index]"
                                    :id="'rtop'+rtop.id" :value="rtop.id">
                              <span class="material-control-indicator"></span>
                              <span class="material-control-description">{{lan == 'en'?rtop.en_required_position:rtop.jp_required_position}}</span>
                            </label>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div v-if="!$v.requiredposition.req && requiredPositionFocus" style="margin-top: -10px;" class="help-block">{{$t('required_filed')}}</div>
                    </div>
                  </div>
                </div>
                <div class="col-md-2"></div>
              </div>

              <div class="row text-left">
                <div class="col-md-2"></div>
                <div class="col-md-2 input" :class="{ invalid: $v.requriedTypeOfContract.$error}">
                  <label class="mplus2p-m spacing1-2 black peditlabel">{{$t('ep_requried_type_of_contract')}} <span style="color: red;">*</span></label>
                </div>
                <div class="col-md-6 errorClass" :class="{ invalid: $v.requriedTypeOfContract.$error}">
                  <div class="row peselectboxs2">
                    <div class="col-md12">
                      <div class="form-group" style="min-width: 415px;">
                        <ul class="list-unstyled mt-3 peselectboxs form-control listError custom-wrapper" id="rtoc-block">
                          <li v-for="(rtoc,index) of requriedTypeOfContracts" :key="index">
                            <label :for="'rtoc'+rtoc.id" class="custom-control material-checkbox">
                              <input type="checkbox" class="material-control-input" @change="errorCheckContract()" v-model="check_type_contract[index]"
                                    :id="'rtoc'+rtoc.id" :value="rtoc.id">
                              <span class="material-control-indicator"></span>
                              <span class="material-control-description">{{lan == 'en'?rtoc.en_required_type:rtoc.jp_required_type}}</span>
                            </label>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="col-md-12">
                       <div v-if="!$v.requriedTypeOfContract.req && requriedTypeOfContractFocus" style="margin-top: -10px;" class="help-block">{{$t('required_filed')}}</div>
                    </div>
                  </div>
                </div>
                <div class="col-md-2"></div>
              </div>

              <div class="row text-left">
                <div class="col-md-2"></div>
                <div class="col-md-2 input" :class="{ invalid: $v.requiredWorkArea.$error}">
                  <label class="mplus2p-m spacing1-2 black peditlabel">{{$t('ep_required_work_area_to_be')}} <span style="color: red;">*</span></label>
                </div>
                <div class="col-md-6 errorClass"  :class="{ invalid: $v.requiredWorkArea.$error}">
                  <div class="row peselectboxs2">
                    <div class="col-md12">
                      <div class="form-group" style="min-width: 415px;">
                        <ul class="list-unstyled mt-3 peselectboxs form-control listError custom-wrapper" id="wantedjob-block">
                          <li v-for="(rtow,index) of requiredWorkAreas" :key="index">
                            <label :for="'rtow'+rtow.id" class="custom-control material-checkbox">
                              <input type="checkbox" class="material-control-input" @change="errorRequiredWorkArea()" v-model="check_work_area_to_be[index]"
                                    :id="'rtow'+rtow.id" :value="rtow.id">
                              <span class="material-control-indicator"></span>
                              <span class="material-control-description">{{lan == 'en'?rtow.en_work_area:rtow.jp_work_area}}</span>
                            </label>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="col-md-12">
                        <div v-if="!$v.requiredWorkArea.req && requiredWorkAreaFocus" style="margin-top: -10px;" class="help-block">{{$t('required_filed')}}</div>
                    </div>
                  </div>
                </div>
                <div class="col-md-2"></div>
              </div>

              <div class="row text-left">
                <div class="col-md-2"></div>
                <div class="col-md-2">
                  <label class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('ep_desired')}}</label>
                </div>
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-12">
                      <div  class="selectdiv peselectboxs form-group" style="min-width: 170px;">
                        <select class="form-control" name="experience" v-model="sel_desiar_engineer.id" autofocus>
                          <option v-if="sel_desiar_engineer.id == ''" class="mplus2p-r black" style="font-size: 0.875rem;" value="">{{$t('r_select')}}</option>
                          <option v-for="(i,index) of desiar_engineer" :key="index" class="mplus2p-r black" style="font-size: 0.875rem;" :selected="sel_desiar_engineer.id" :value="i.id">{{lan == 'en' ? i.en_type : i.jp_type}}
                          </option>
                        </select>
                      </div>
                      <div class="peselectboxs form-group" style="width: 115px;">
                        <vue-numeric ref="numaric_income" class="peditboxes  form-control" id="numaric_income"  separator="," v-model="income" style="height: 50px;margin-top: 5px;"></vue-numeric>
                      </div>
                      <div class="peselectboxs form-group" style="margin-top:17px;height:43px;min-width: 45px;" >
                          <span>{{$t('ep_currency_unit')}}</span>
                      </div>
                    </div>
                  </div>
                 </div>
                  <div class="col-md-2"></div>
              </div>

              <div class="row text-left">
                 <div class="col-md-2"></div>
                <div class="col-md-2">
                  <label class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('ep_policy')}}</label>
                </div>
                <div class="col-md-6">
                    <div class="regselectboxs form-group" style="min-width: 415px;">
                      <input style="min-height:50px"  @keydown.enter.prevent :placeholder="$t('unify_test')"  v-model="policy" class="form-control" name="policy" autofocus />
                    </div>
                </div>
                <div class="col-md-2"></div>
              </div>

              <div class="row text-left">
                    <div class="col-md-2"></div>
                    <div class="col-md-2">
                      <label class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('ep_experience')}}</label>
                    </div>
                    <div class="col-md-6">
                      <div  class="selectdiv peselectboxs form-group" style="min-width: 415px;">

                        <select class="form-control" name="experience" v-model="sel_experience" autofocus>
                          <option v-if="sel_experience == ''" class="mplus2p-r black" style="font-size: 0.875rem;" value="">{{$t('r_select')}}</option>
                          <option v-for="(i,index) of experiences" :key="index" class="mplus2p-r black" style="font-size: 0.875rem;" :selected="sel_experience.id" :value="i.id">{{lan == 'en' ? i.en_experience : i.jp_experience}}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-2"></div>
                </div>

                <div class="row text-left">
                  <div class="col-md-2"></div>
                  <div class="col-md-2">
                    <label class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('ep_current_position')}}</label>
                  </div>

                  <div class="col-md-6">
                    <div class="selectdiv peselectboxs form-group" style="min-width: 415px;">
                      <select class="form-control" name="wantedJobCondition" v-model="sel_current_position" autofocus>
                        <option class="mplus2p-r black" style="font-size: 0.875rem;" value="">{{$t('r_select')}}</option>
                        <option v-for="(i,index) of current_position" :key="index" class="mplus2p-r black" style="font-size: 0.875rem;" :selected="sel_current_position.id" :value="i.id">{{lan == 'en' ? i.en_required_position : i.jp_required_position}}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-2"></div>
                </div>

                <div class="row text-left">
                  <div class="col-md-2"></div>
                  <div class="col-md-2">
                    <label class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('ep_current_type_of_contract')}}</label>
                  </div>

                  <div class="col-md-6">
                    <div class="selectdiv peselectboxs form-group" style="min-width: 415px;">
                      <select class="form-control" name="wantedJobCondition" v-model="selCurrentContract" autofocus>
                        <option class="mplus2p-r black" style="font-size: 0.875rem;" value="">{{$t('r_select')}}</option>
                        <option v-for="(i,index) of currentContract" :key="index" class="mplus2p-r black" style="font-size: 0.875rem;" :selected="selCurrentContract.id" :value="i.id">{{lan == 'en' ? i.en_required_type : i.jp_required_type}}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-2"></div>
                </div>

                 <div class="row text-left">
                    <div class="col-md-2"></div>
                    <div class="col-md-8"  >
                      <div class="input" :class="{ invalid: experienced_corporateFocus || position_overviewFocus || started_atFocus || started_atFocus || responsibilityFocus}">
                        <label class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('ep_past_job_details')}} <span style="color: red;">*</span></label>
                      </div>
                      <div  class="textGray"  v-for="(item, index) in job_details" :key="index">
                         <div class="input" :class="{ invalid: index === 0 && experienced_corporateFocus }">
                          <div class="selectdiv dynamicSelect form-group">
                            <select  @change="experienced_corporate()" class="form-control mb-3 " name="location" v-model="item.sel_experienced_corporate" autofocus>
                              <option v-if="item.sel_experienced_corporate == ''" class="mplus2p-r black" style="font-size: 0.875rem;" :value="''">{{$t('r_select_exp_corp')}}</option>
                              <option v-for="(i,index) of experiencedCorporate" :key="index" class="mplus2p-r black" style="font-size: 0.875rem;" :value="i.id">{{lan == "en" ? i.en_corporate : i.jp_corporate}}
                              </option>
                            </select>
                          </div>
                        </div>
                        <div class=" mb-3 input"  :class="{ invalid: index === 0 && position_overviewFocus }">
                          <input @input="positionOverview()" @keydown.enter.prevent :placeholder="$t('unify_test_pos')" style="max-width: 710px;" maxlength="45" v-model="item.position_overview" class="peditboxes peditinput  form-control" name="policy" autofocus />
                        </div>
                        <div class="form-group" style="margin-left:1.2rem;"  >
                          <div class="row" >
                            <div class='col-md-6 input' :class="{ invalid: index === 0 && started_atFocus }">
                              <date-picker @input="startDate()"  :clearable="false" :change="startCheckDate('started_at'+index)" :id="'started_at'+index" :editable="false" input-class="textGra peditboxes mx-input form-control "  width="100%" :placeholder="$t('ep_started_at')" v-model="item.started_at"  lang="en"  format="YYYY/MM"></date-picker>
                            </div>
                            <div class='col-md-6 input' :class="{ invalid: index === 0 && ended_atFocus }">
                              <date-picker @input="endDate()"  :clearable="false" :change="endCheckDate('ended_at'+index)" :id="'ended_at'+index" :editable="false" input-class="textGra peditboxes mx-input form-control "  width="100%" :placeholder="$t('ep_ended_at')" v-model="item.ended_at"  lang="en"  format="YYYY/MM"></date-picker>
                            </div>
                          </div>
                        </div>
                        <div class="mt-3 input" :class="{ invalid: index === 0 && responsibilityFocus }">
                          <textarea @input="response()"  rows="5"  style="max-width: 710px;" class="enterPrevent peditboxes pedittextarea form-control" name="profile_summary" v-model="item.responsibility" autofocus :placeholder="$t('unify_test_what_resp')">
                          </textarea>
                        </div>
                        <div v-if="index === 0 && (experienced_corporateFocus || position_overviewFocus || started_atFocus || ended_atFocus || responsibilityFocus)" style="margin-left:20px;" class="help-block">{{$t('ep_past_job_details_error2')}}</div>
                        <div class="mt-1" style="margin-bottom: 60px" v-if="index !=  job_details.length - 1">
                          <button type="button" class="btn btn-danger clickcbtn"  @click.prevent="onDeleteHobby(index,item.id)" style="float: right;">
                            <i class="fa fa-trash "></i>
                          </button>
                        </div>
                      </div>
                      <div class="mt-2">
                      <button type="button" :disabled='job_details.length == 30' class="btn whitebtn clickcbtn"  @click.prevent="onAddJobDetail()" style="float: right;">
                          <i class="fa fa-plus "></i>
                        </button>
                      </div>
                    </div>
                    <div class="col-md-2"></div>
                 </div>

              <div class="row">
                <div v-if="lan === 'en'" class="col-sm-12 text-center regalert_txt">
                   <p >{{$t('r_registration_alert')}}
                      <router-link class='term' to="/global/terms-of-service" target='_blank'> {{$t('r_term')}}</router-link> {{$t('r_END')}}
                      <router-link class='policy' to='/global/privacy-policy' target='_blank'>{{$t('r_poicy')}}</router-link>
                    </p>
                </div>
                <div v-if="lan === 'jp'" class="col-sm-12 text-center regalert_txt">
                  <p>
                      <router-link class='term' to='/global/terms-of-service' target='_blank'>{{$t('r_term')}}</router-link> {{$t('r_END')}}
                      <router-link class='policy' to='/global/privacy-policy' target='_blank'>{{$t('r_poicy')}}</router-link> {{$t('r_registration_alert')}}
                  </p>
                </div>
              </div>
              <div class="row text-left">
                <div class="col-md-3"></div>
                <div class="col-md-6">
                  <button type="submit" class="btn register bluebtn mplus2p-r spacing1-2 regnext_btn">
                    {{$t('r_button')}}
                  </button>
                  <router-link to="/global/signin">
                    <p class="skipbtn mplus2p-m spacing1-2 blue">{{$t('r_back_to_login')}}</p>
                  </router-link>
                </div>
                <div class="col-md-3"></div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Hashids from "hashids";
import moment from 'moment';
  import {validationMixin} from "vuelidate";
  import {
    required,
    maxLength,
    email,
    minLength,
    minValue,
    sameAs
  } from "vuelidate/lib/validators";
  import axios from "axios";
  import {EventBus} from "../../../main.js";
  import VueNumeric from 'vue-numeric'
  import DatePicker from "vue2-datepicker";

  const customValidation = value => {
    return /^[a-zA-Z]\.[a-zA-Z]?$/.test(value)
  }
  export default {
    mixins: [validationMixin],

    validations: {
      initials: {req: required, maxLength: maxLength(20), customValidation},
      firstname: {req: required, minLength: minLength(1)},
      lastname: {req: required, minLength: minLength(1)},
      firstNamePhonetic: {req: required, minLength: minLength(1)},
      lastNamePhonetic: {req: required, minLength: minLength(1)},
      password: {req: required, minLength: minLength(6)},
      cPassword: {req: required,sameAsPassword: sameAs("password")},
      email: {req: required, email},
      year: {req: required},
      month: {req: required},
      day: {req: required},
      requiredposition: {req: required},
      requiredWorkArea: {req: required},
      requriedTypeOfContract: {req: required},
    },

    data() {
      return {
        model: {},
        loading: false,
        firstNameFocus: false,
        lastNameFocus: false,
        firstNamePhoneticFocus: false,
        lastNamePhoneticFocus: false,
        initialsFocus: false,
        initialsAlphaValidationFocus: false,
        emailFocus: false,
        passwordFocus: false,
        cPasswordFocus: false,
        yearFocus: false,
        monthFocus: false,
        dayFocus: false,
        expertisFocus: false,
        jobSeekingFocus: false,
        typeOfContractFocus: false,
        requiredPositionFocus: false,
        requiredWorkAreaFocus: false,
        requriedTypeOfContractFocus: false,
        experienced_corporateFocus: false,
        position_overviewFocus: false,
        responsibilityFocus: false,
        started_atFocus: false,
        ended_atFocus: false,
        firstname: "",
        lastname: "",
        firstNamePhonetic: "",
        lastNamePhonetic: "",
        initials: "",
        email: "",
        emailDisabled: false,
        password: "",
        cPassword: "",
        years: [],
        year: '',
        months: [],
        month: '',
        days: [],
        day: '',
        expertises: [],
        expertise : { id: "" },
        jobSeekings: [],
        jobSeeking: { id: "" },

        requiredpositions: [],
        requiredposition: [],
        check_require_position: [],

        locations: [],
        location: { id: "" },


        requiredWorkAreas: [],
        requiredWorkArea: [],
        check_work_area_to_be: [],

        requriedTypeOfContracts: [],
        requriedTypeOfContract: [],

        desc: "",

        sel_national: { id: "" },
        nationals: [],

        sel_language: [],
        languages: [],
        check_language: [],

        sel_desiar_engineer: { id: "" },
        desiar_engineer: [],
        result : '',
        income: '',

        job_details: [{
          sel_experienced_corporate: '',
          position_overview: '',
          responsibility: '',
          started_at: '',
          ended_at : ''
        }],

        selCurrentContract: '',
        currentContract: [],
        check_type_contract: [],

        sel_current_position: "",
        current_position: [],

        sel_experience: "",
        experiences: [],

        experiencedCorporate: [],

        policy: "",

        roleToHandle: "",

        lan: "jp"
      };
    },
  components: {
    VueNumeric,
    DatePicker
  },
    created() {
      var hashids = new Hashids(
        "this is admin approve",
        8,
        "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890"
      );
      if (this.$route.params.id) {
        this.getUser(hashids.decode(this.$route.params.id))
      }
      if ("lan" in localStorage) {
        this.lan = localStorage.getItem("lan");
      }
      for (let i = 1950; i <=  moment().format('YYYY'); i++) {
        this.years.push(i);
      }
      for (let i = 1; i <= 12; i++) {
        this.months.push(i);
      }
      for (let i = 1; i <= 31; i++) {
        this.days.push(i);
      }
    },
    mounted() {
      EventBus.$on("language", data => {
        this.lan = data;
      });
      $(this.$refs['numaric_income'].$el).keypress(function(e){
          if ( e.keyCode === 13 ) return e.preventDefault();
      });

       this.getFormType();

      this.getCurrentposition();

      this.getRecuiredPosition();

      this.getRecuiredTypeOfContract()

      this.getExpereance();

      this.getIncomeType();

      this.getNational();

      this.getJobSeeking();

      this.getLoacation();

      this.getWorkAreas();

      this.getLanguages();

      this.getExpertises();

      this.getExperiencedCorporate();

    },
    methods: {
    experienced_corporate(){
      this.experienced_corporateFocus = false;
    },
    positionOverview(){
      this.position_overviewFocus = false;
    },
    startDate(){
      this.started_atFocus = false;
    },
    endDate(){
      this.ended_atFocus = false;
    },
    response(){
      this.responsibilityFocus = false;
    },
    errorCheckContract(){
      let vm = this;
      var arr2 = [];
      for (var i = 0; i <= this.check_type_contract.length - 1; i++) {
        if (this.check_type_contract[i]) {
          arr2.push(this.requriedTypeOfContracts[i].id);
        }
      }
      if (arr2.length == 0) {
        this.requriedTypeOfContract = ''

      }
      else{
        this.requriedTypeOfContract = 'ok'
        this.typeOfContractFocus = false
      }
    },
    errorRequiredPosition(){
      let vm = this;
      var arr2 = [];
      for (var i = 0; i <= this.check_require_position.length - 1; i++) {
        if (this.check_require_position[i]) {
          arr2.push(this.requiredpositions[i].id);
        }
      }
      if (arr2.length == 0) {
        this.requiredposition = '';

      }
      else{
        this.requiredposition = 'ok';
        this.requiredPositionFocus = false;

      }
    },
    errorRequiredWorkArea(){
      let vm = this;
      var arr2 = [];
      for (var i = 0; i <= this.check_work_area_to_be.length - 1; i++) {
        if (this.check_work_area_to_be[i]) {
          arr2.push(this.requiredWorkAreas[i].id);
        }
      }
      if (arr2.length == 0) {
        this.requiredWorkArea = ''

      }
      else{
        this.requiredWorkArea = 'ok'
        this.requiredWorkAreaFocus = false
      }
    },
    startCheckDate(value){
      $('#'+value).keypress(function(e){
        if ( e.keyCode === 13 ) return e.preventDefault();
      });
    },
    endCheckDate(value){
      $('#'+value).keypress(function(e){
          if ( e.keyCode === 13 ) return e.preventDefault();

      });
    },
    onAddJobDetail () {
      const newJob = {
        sel_experienced_corporate: '',
        position_overview: '',
        responsibility: '',
        started_at: '',
        ended_at: '',
      }
      this.job_details.push(newJob)
    },
    onDeleteHobby (index,id) {
      if (id != undefined) {
        var formData = new FormData();
        formData.append("past_job_detail_id", id);
          axios
          .post("/delete-past-job-experience?token="+ localStorage.getItem("token"), formData)
          .then(res => {
            this.job_details.splice(index, 1)
      })
      .catch(error => console.log(error));
      }else{
        this.job_details.splice(index, 1)
      }
    },

    getFormType() {
      axios
        .get("/user-position-types")
        .then(res => {
          this.currentContract = res.data.types;
        })
        .catch(error => console.log(error));
    },
     getRecuiredTypeOfContract() {
      axios
        .get("/user-position-types")
        .then(res => {
          this.requriedTypeOfContracts = res.data.types;
          this.isSelectedTypeContract();
        })
        .catch(error => console.log(error));
    },
    isSelectedTypeContract(){
        for (var i = 0; i <= this.requriedTypeOfContracts.length - 1; i++) {
        var isSelected = this.requriedTypeOfContract.findIndex(obj => {
          return obj.id == this.requriedTypeOfContracts[i].id;
        });
        this.check_type_contract[i] = isSelected != -1 ? true : false;
      }
      this.$forceUpdate();
    },
    getCurrentposition() {
      axios
        .get("/user-positions")
        .then(res => {
          this.current_position = res.data.positions;
        })
        .catch(error => console.log(error));
    },
     getRecuiredPosition() {
      axios
        .get("/user-positions")
        .then(res => {
          this.requiredpositions = res.data.positions;
          this.isSelectedRecuiredPosition();
        })
        .catch(error => console.log(error));
    },
    isSelectedRecuiredPosition(){
        for (var i = 0; i <= this.requiredpositions.length - 1; i++) {
        var isSelected = this.requiredposition.findIndex(obj => {
          return obj.id == this.requiredpositions[i].id;
        });
        this.check_require_position[i] = isSelected != -1 ? true : false;
      }
      this.$forceUpdate();
    },
    getExpereance() {
      axios
        .get("/experiences")
        .then(res => {
          this.experiences = res.data.experiences;
        })
      .catch(error => console.log(error));
    },
    getIncomeType(){
      axios
        .get("/income-types")
        .then(res => {
            this.desiar_engineer = res.data.types;
        })
        .catch(error => console.log(error));
    },
    getNational() {
      axios
        .get("/nationals")
        .then(res => {
          this.nationals = res.data.nationals;
        })
        .catch(error => console.log(error));
    },
    getJobSeeking() {
      axios
        .get("/job-seeking-situations")
        .then(res => {
          this.jobSeekings = res.data.situations;
        })
        .catch(error => console.log(error));
    },
    getLoacation() {
      axios
        .get("/locations")
        .then(res => {
          this.locations = res.data.locations;
        })
        .catch(() => {
          this.$toaster.error(thisVue.$t("err_network"));
        });
    },
    getWorkAreas() {
      axios
        .get("/work-areas")
        .then(res => {
          this.requiredWorkAreas = res.data.work_areas;
          this.isSelectedWorkArea()
        })
        .catch(error => console.log(error));
    },
    isSelectedWorkArea(){
        for (var i = 0; i <= this.requiredWorkAreas.length - 1; i++) {
        var isSelected = this.requiredWorkArea.findIndex(obj => {
          return obj.id == this.requiredWorkAreas[i].id;
        });
        this.check_work_area_to_be[i] = isSelected != -1 ? true : false;
      }
      this.$forceUpdate();
    },
    getLanguages() {
    axios
      .get("/engineer-languages")
      .then(res => {
        this.languages = res.data.languages;
        this.isSelectedLanguage();
      })
      .catch(error => console.log(error));
    },
    isSelectedLanguage(){
        for (var i = 0; i <= this.languages.length - 1; i++) {
        var isSelected = this.sel_language.findIndex(obj => {
          return obj.id == this.languages[i].id;
        });
        this.check_language[i] = isSelected != -1 ? true : false;
      }
      this.$forceUpdate();
    },
    getExpertises() {
      axios
        .get("/expertises")
        .then(res => {
          this.expertises = res.data.item;
        })
        .catch(error => console.log(error));
    },
    getExperiencedCorporate() {
      axios
      .get("/experienced-corporates")
      .then(res => {
        this.experiencedCorporate = res.data.corporates;
      })
      .catch(error => console.log(error));
    },
    clickedSex(flag) {
      if (flag === 1) {
        this.model.sex = 1;
        $(".womenradio").removeClass("wchosen");
        $(".otherradio").removeClass("ochosen");
        $(".manradio").addClass("mchosen");
      }
      if (flag === 2) {
        this.model.sex = 2;
        $(".manradio").removeClass("mchosen");
        $(".otherradio").removeClass("ochosen");
        $(".womenradio").addClass("wchosen");
      }
      if (flag === 3) {
        this.model.sex = 3;
        $(".manradio").removeClass("mchosen");
        $(".otherradio").addClass("ochosen");
        $(".womenradio").removeClass("wchosen");
      }
    },
    getUser(id){
        this.loading = true;
      let self = this;
      axios
        .get("/user/" + id[0], {
          headers: { "X-localization": localStorage.getItem("lan") }
        })
        .then(res => {
          if (!res.data.result) {
            if (res.data[0]) {
              this.$toaster.error(res.data[0]);
              this.$store.dispatch("logout");
            }
            if (res.data.errors) {
              for (var i = 0; i < res.data.errors.length; i++) {
                this.$toaster.error(res.data.errors[i].message);
              }
            }
            this.loading = false;
          } else {
            this.firstname = res.data.user.first_name;
            this.lastname = res.data.user.last_name;
            this.firstNamePhonetic = res.data.user.first_name_phonetic
            this.lastNamePhonetic = res.data.user.last_name_phonetic
            this.initials = res.data.user.initials;
            if (res.data.user.email) {
              this.email = res.data.user.email;
              this.emailDisabled = true;
            }
            if (res.data.user.income_type_id != null) {
              this.sel_desiar_engineer =  res.data.user.income_type_id;
            } else {
              this.sel_desiar_engineer = { id: "" };
            }
            if (res.data.user.job_seeking_situation != null) {
              this.jobSeeking = res.data.user.job_seeking_situation;
            } else {
              this.jobSeeking = { id: "" };
            }
            this.income = res.data.user.income;
            this.expertise = res.data.user.expertise
              ? res.data.user.expertise
              : { id: "" };

            if (res.data.user.gender && res.data.user.gender.id == "1") {
              this.sex = "1";
              $(".womenradio").removeClass("wchosen");
              $(".manradio").addClass("mchosen");
              $(".otherradio").removeClass("ochosen");
            } else if (res.data.user.gender && res.data.user.gender.id == "2") {
              this.sex = "2";
              $(".manradio").removeClass("mchosen");
              $(".womenradio").addClass("wchosen");
              $(".otherradio").removeClass("ochosen");
            } else if (res.data.user.gender && res.data.user.gender.id == "3") {
              this.sex = "3";
              $(".manradio").removeClass("mchosen");
              $(".womenradio").removeClass("wchosen");
              $(".otherradio").addClass("ochosen");
            } else {
              $(".manradio").removeClass("mchosen");
              $(".womenradio").removeClass("wchosen");
              $(".otherradio").removeClass("ochosen");
            }
            setTimeout(() => {
              this.loading = false;
            }, 500);
          }
        })
        .catch(error => console.log(error));
    },
    doRegisterFirst() {
      this.loading = true;
      const thisVue = this;

      this.$v.$touch();
      if (this.$v.$invalid ) {
        this.firstNameFocus = true
        this.lastNameFocus = true
        this.firstNamePhoneticFocus = true
        this.lastNamePhoneticFocus = true
        this.initialsFocus = true
        if(this.initials != '') {
          this.initialsAlphaValidationFocus = true
        }
        this.emailFocus = true
        this.passwordFocus = true
        this.cPasswordFocus = true
        this.yearFocus = true
        this.monthFocus = true
        this.dayFocus = true
        this.expertisFocus = true
        this.jobSeekingFocus = true
        this.requiredPositionFocus = true
        this.requriedTypeOfContractFocus = true
        this.requiredWorkAreaFocus = true
        if (this.job_details[0].sel_experienced_corporate == '') {
          this.experienced_corporateFocus = true;
        }
        if (this.job_details[0].position_overview == '') {
          this.position_overviewFocus = true;
        }
        if ( this.job_details[0].started_at == '') {
          this.started_atFocus = true;
        }
        if (this.job_details[0].ended_at == '' ) {
          this.ended_atFocus = true;
        }
        if (this.job_details[0].responsibility == '' ) {
          this.responsibilityFocus = true;
        }
        this.loading = false;
        setTimeout(() => {
          $('html, body').animate({scrollTop:$($('.invalid')[0]).position().top+20}, 'slow');
        },100);
      }
      else if( this.job_details[0].sel_experienced_corporate == '') {
        this.experienced_corporateFocus = true;
        $('html, body').animate({scrollTop:2700}, 'slow');
        this.loading = false;
      }
      else if ( this.job_details[0].position_overview == '') {
        this.position_overviewFocus = true;
        $('html, body').animate({scrollTop:2700}, 'slow');
        this.loading = false;
      }
      else if ( this.job_details[0].started_at == '') {
        this.started_atFocus = true;
        $('html, body').animate({scrollTop:2700}, 'slow');
        this.loading = false;
      }
      else if (this.job_details[0].ended_at == '' ) {
        this.ended_atFocus = true;
        $('html, body').animate({scrollTop:2700}, 'slow');
        this.loading = false;
      }
      else if (this.job_details[0].responsibility == '' ) {
        this.responsibilityFocus = true;
        $('html, body').animate({scrollTop:2700}, 'slow');
        this.loading = false;
      }
      else {
        var formData = new FormData();
        formData.append("first_name", this.firstname);
        formData.append("last_name", this.lastname);
        formData.append("first_name_phonetic", this.firstNamePhonetic);
        formData.append("last_name_phonetic", this.lastNamePhonetic);
        formData.append("initials", this.initials);
        formData.append("password", this.password);
        formData.append("confirm_password", this.cPassword);
        formData.append("year", this.year);
        formData.append("month", this.month);
        formData.append("day", this.day);
        if (this.model.sex) {
          formData.append("gender_id", this.model.sex);
        }
        formData.append("career_summary",  this.desc ? this.desc : '');
        formData.append("location_id", this.location.id);
        formData.append("expertise_id", this.expertise.id);
        formData.append("job_seeking_situation_id", this.jobSeeking.id);
        formData.append("national_id", this.sel_national.id);
        formData.append("income",  this.income );
        formData.append("policy", this.policy ? this.policy : '');
        formData.append("role_to_handle", this.roleToHandle);
        formData.append("current_position_id", this.sel_current_position);
        formData.append("current_contract_id", this.selCurrentContract);
        formData.append("experience_id", this.sel_experience);
        for (var i = 0; i < this.job_details.length; i++) {
          if (this.job_details[i].sel_experienced_corporate != '' || this.job_details[i].ended_at != '' || this.job_details[i].position_overview != '' || this.job_details[i].responsibility != '' || this.job_details[i].started_at != '') {
            formData.append("past_job_details[" + i + "][experienced_corporate]", this.job_details[i].sel_experienced_corporate)
            formData.append("past_job_details[" + i + "][position_overview]", this.job_details[i].position_overview)
            formData.append("past_job_details[" + i + "][responsibility]", this.job_details[i].responsibility)
            if(moment(this.job_details[i].started_at).format('YYYY/MM') > moment(this.job_details[i].ended_at).format('YYYY/MM'))
            {
              this.$toaster.error(i+1+'. ' + this.$t('ep_date_validation'));
              this.loading = false;
              return;
            }
            else{
              formData.append("past_job_details[" + i + "][started_at]", moment(this.job_details[i].started_at).format('YYYY/MM'))
              formData.append("past_job_details[" + i + "][ended_at]", moment(this.job_details[i].ended_at).format('YYYY/MM'))
            }
          }
        }

          var required_position = [];
          for (var i = 0; i < this.check_require_position.length; i++) {
            if (this.check_require_position[i]) {
              required_position.push(this.requiredpositions[i].id);
            }
          }

        for (var i = 0; i < required_position.length; i++) {
          formData.append("required_position[" + i + "]", required_position[i])
        }

        var language = [];
          for (var i = 0; i < this.check_language.length; i++) {
            if (this.check_language[i]) {
              language.push(this.languages[i].id);
            }
          }
          for (var i = 0; i < language.length; i++) {
            formData.append("language[" + i + "]", language[i])
          }
          var required_contract = [];
          for (var i = 0; i < this.check_type_contract.length; i++) {
            if (this.check_type_contract[i]) {
              required_contract.push(this.requriedTypeOfContracts[i].id);
            }
          }
          for (var i = 0; i < required_contract.length; i++) {
            formData.append("required_contract[" + i + "]", required_contract[i])
          }

          var required_work_area_to_be = [];
          for (var i = 0; i < this.check_work_area_to_be.length; i++) {
            if (this.check_work_area_to_be[i]) {
              required_work_area_to_be.push(this.requiredWorkAreas[i].id);
            }
          }
          for (var i = 0; i < required_work_area_to_be.length; i++) {
            formData.append("required_work_area_to_be[" + i + "]", required_work_area_to_be[i])
          }
        if (this.$route.params.id) {
          var hashids = new Hashids(
              "this is admin approve",
              8,
              "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890"
            );
             formData.append("user_id", hashids.decode(this.$route.params.id))
              formData.append("income_type",  this.sel_desiar_engineer.id);
           axios
            .post(
              "/admin-register",
              formData,
              {
                headers: { "X-localization": localStorage.getItem("lan") }
              }
            )
            .then(res => {
              if (!res.data.result) {
                if (res.data[0]) {
                  this.$toaster.error(res.data[0]);
                  this.$store.dispatch("logout");
                }
                if (res.data.errors) {
                  for (var i = 0; i < res.data.errors.length; i++) {
                    if (res.data.errors[i].field === "initials") {
                      this.$toaster.error(res.data.errors[i].message);
                    }
                    if (res.data.errors[i].field === "password") {
                      this.$toaster.error(res.data.errors[i].message);
                    }
                    if (res.data.errors[i].field === "expertise") {
                      this.$toaster.error(res.data.errors[i].message);
                    }
                    if (res.data.errors[i].field === "job_seeking_situation_id") {
                      this.$toaster.error(res.data.errors[i].message);
                    }
                    if (res.data.errors[i].field === "confirm_password") {
                      this.$toaster.error(res.data.errors[i].message);
                    }
                    if (res.data.errors[i].field === "year") {
                      this.$toaster.error(res.data.errors[i].message);
                    }
                    if (res.data.errors[i].field === "month") {
                      this.$toaster.error(res.data.errors[i].message);
                    }
                    if (res.data.errors[i].field === "day") {
                      this.$toaster.error(res.data.errors[i].message);
                    }
                    this.$toaster.error(res.data.errors[i].message);
                  }
                }
                this.loading = false;
              } else {
                  this.loading = false;
                  this.$store.dispatch("signup", res);
                  this.$toaster.success(thisVue.$t("success_register_completed"));
                  this.$v.$reset();
                  this.firstname = "";
                  this.lastname = "";
                  this.email = "";
                  this.password = "";
                  this.cPassword = "";
                  this.year = "";
                  this.month = "";
                  this.day = "";
                  this.model.sex = 3;
                  this.location = "";
                  this.expertise = '';
                  this.requiredWorkArea = [];
                  this.requriedTypeOfContract = [];
              }
            })
            .catch(() => {
              let thisVue = this;
              this.$toaster.error(thisVue.$t("err_network"));
            });
        }
        else{
          formData.append("email", this.email);
           formData.append("income_type_id",  this.sel_desiar_engineer.id);
           return axios
          .post("/register", formData, {
            headers: {"X-localization": localStorage.getItem("lan")}
            }).then(res => {
          this.result = res;
          if (!res.data.result) {
            for (var i = 0; i < res.data.errors.length; i++) {
              if (res.data.errors[i].field === "initials") {
                this.$toaster.error(res.data.errors[i].message);
              }
              if (res.data.errors[i].field === "email") {
                this.$toaster.error(res.data.errors[i].message);
              }
              if (res.data.errors[i].field === "password") {
                this.$toaster.error(res.data.errors[i].message);
              }
              if (res.data.errors[i].field === "expertise") {
                this.$toaster.error(res.data.errors[i].message);
              }
              if (res.data.errors[i].field === "job_seeking_situation_id") {
                this.$toaster.error(res.data.errors[i].message);
              }
              if (res.data.errors[i].field === "confirm_password") {
                this.$toaster.error(res.data.errors[i].message);
              }
              if (res.data.errors[i].field === "year") {
                this.$toaster.error(res.data.errors[i].message);
              }
              if (res.data.errors[i].field === "month") {
                this.$toaster.error(res.data.errors[i].message);
              }
              if (res.data.errors[i].field === "day") {
                this.$toaster.error(res.data.errors[i].message);
              }
            }
            this.loading = false;
          }
          else {
            this.loading = false;
            this.$store.dispatch("signup", res);
            this.$toaster.success(thisVue.$t("success_register"));
            this.$v.$reset();
            this.firstname = "";
            this.lastname = "";
            this.email = "";
            this.password = "";
            this.cPassword = "";
            this.year = "";
            this.month = "";
            this.day = "";
            this.model.sex = 3;
            this.location = "";
            this.expertise = '';
            this.requiredWorkArea = [];
            this.requriedTypeOfContract = [];
          }
        }).catch(() => {
          this.loading = false;
          this.$toaster.error(thisVue.$t("err_network"));
        });
        }
      }
    }
  }
};
</script>

<style scoped>
.dynamicSelect{
      margin-left: 20px;
}

.textGray .form-control{
  color: gray;
  margin-left: 20px;
}

.clickcbtn {
  border-radius: 20px;
  padding: 7px 14px;
  box-shadow: 0 1px 4px 0 rgba(40, 60, 80, 0.4);
  float: right;
}
.peditlabel {
  font-size: 1rem;
  font-weight: 500;
  margin-left: 20px;
  margin-top: 17px;
}

  .mainbody:after {
    position: absolute;
    content: url("../../../assets/imgs/zoomtool.png");
    top: -1px;
    right: 190px;
    margin-top: 25px;
  }

  .regselectboxs {
    float: left;
    margin-left: 16px;
  }

  .reglabels {
    font-size: 0.875rem;
    font-weight: 600;
    padding: 20px 0;
  }
  .peditinput{
    width: 100%;
    height: 44px;
    padding: 0px 16px;
    margin-left: 20px;
  }
  .regradioboxs {
    text-align: center;
    min-width: 145px;
    height: 50px;
    float: left;
    background-color: #ffffff;
    border: 1px solid #b4bec8;
    color: #b4bec8;
    margin-left: 16px;
    margin-top: 5px;
    padding-top: 10px;
    border-radius: 4px;
    cursor: pointer;
  }

  .manradio:hover,
  .mchosen {
    border: 1px solid #3d7dd8;
    color: #3d7dd8;
  }

  .womenradio:hover,
  .wchosen {
    border: 1px solid #f878c8;
    color: #f878c8;
  }

  .otherradio:hover,
  .ochosen {
    border: 1px solid #5e5e5e;
    color: #5e5e5e;
  }


  .regradiotxt {
    font-size: 0.875rem;
    font-weight: bold;
  }

  .input.invalid label {
    color: red;
  }

  .input.invalid input {
    border: 1px solid red;
    background-color: #ffc9aa;
  }
  .input.invalid select{
    border: 1px solid red;
    background-color: #ffc9aa;
  }
    .input.invalid textarea{
    border: 1px solid red;
    background-color: #ffc9aa;
  }
  .input.invalid .mx-datepicker {
    border: 1px solid red;
    background-color: #ffc9aa;
  }

   .errorClass.invalid label{
    color: red
  }
  .errorClass.invalid .material-control-description{
    color: black
  }
  .errorClass.invalid .listError{
    border: 1px solid red !important;
    background-color: #ffc9aa !important;
  }
  /*.input select {
    border: 1px solid #ccc;
    font: inherit;
  }*/

  .regalert_txt {
    margin-top: 20px;
  }

  .regnext_btn {
    width: 100%;
    height: 56px;
    margin-top: 20px;
    font-weight: bold;
    font-size: 1rem;
  }

  .skipbtn {
    margin-top: 25px;
    font-weight: bold;
    font-size: 1rem;
    text-align: center;
  }

  .selectdiv select {
    height: 50px !important;
  }

  .sexerror {
    margin-top: 60px;
    margin-bottom: 20px;
    margin-left: 16px;
  }

  .peselectboxs {
    float: left;
    margin-left: 16px;
  }
  .peselectboxs2 {
    float: left;
    margin-left: 0px;
  }

  .custom-control.material-checkbox {
    --color: #3d7dd8;
  }

  .custom-control.material-checkbox .material-control-input {
    display: none;
  }

  .custom-control.material-checkbox
  .material-control-input:checked
  ~ .material-control-indicator {
    border-color: var(--color);
    -webkit-transform: rotateZ(45deg) translate(1px, -5px);
    transform: rotateZ(45deg) translate(1px, -5px);
    width: 10px;
    border-top: 0px solid #fff;
    border-left: 0px solid #fff;
  }

  .custom-control.material-checkbox .material-control-indicator {
    display: inline-block;
    position: absolute;
    top: 4px;
    left: 0;
    width: 16px;
    height: 16px;
    border: 2px solid #aaa;
    transition: 0.3s;
  }

  .custom-wrapper {
    width: 415px;
    max-height: 250px;
    overflow: auto;
  }
  @media screen and (max-width: 1200px) {
    .mainbody:after {
      right: 100px;
    }

    .regselectboxs {
      float: left;
      margin-left: 5px;
    }

    .regradioboxs {
      margin-left: 5px;
    }

    .sexerror {
      margin-left: 5px;
    }
  }

  @media screen and (max-width: 992px) {
    .mainbody:after {
      right: 0px;
    }

    .regselectboxs {
      float: left;
      width: 100%;
    }

    regradioboxs {
      margin-left: 16px;
    }
  }

  @media screen and (max-width: 768px) {
    .mainbody:after {
      right: -60px;
    }
  }

  @media screen and (max-width: 678px) {
    .mainbody:after {
      right: 0px;
      margin-top: -60px;
    }

    .mainbody {
      margin-top: 40px;
    }
  }

  @media screen and (max-width: 369px) {
    .regradioboxs {
      margin-top: 10px;
      width: 100%;
      margin-left: 0px;
    }
  }
</style>
